export function addOutlookBaseDomain() {
    const base = document.createElement('base');
    base.href = location.origin;
    document.head.appendChild(base);
}
